<footer>
    <div class="text-center p-3 bg-dark text-white">
        &copy; 2024 Accenture
    </div>

</footer>